import { Link } from '@belong/ui';
import clsx from 'clsx';
import { StepsSection } from 'src/components/steps-section/steps-section';
import css from './numbered-steps-section-slice.module.css';

export const NumberedStepsSectionSlice = ({ items }: any) => {
  const data = items.map((item: any) => ({
    src: item.step_image?.url,
    title: (
      <div className={clsx(css.stepsSection1Card1, 'whitespace-pre-line')}>
        {item.step_title}
      </div>
    ),
    hoverState: (item.hover_title || item.hover_body) && {
      title: (
        <div
          className={clsx(css.stepsSection1Card1Hover, 'whitespace-pre-line')}
        >
          {item.hover_title}
        </div>
      ),
      body: item.hover_body,
      action:
        item.hover_cta_link?.url && item.hover_cta_text ? (
          <Link href={item.hover_cta_link.url} shallow>
            {item.hover_cta_text}
          </Link>
        ) : null,
    },
  }));
  return (
    <div className="flex w-full flex-col items-center overflow-hidden md:container lg:w-auto">
      <StepsSection data={data} />
    </div>
  );
};
